export enum SignInProvider {
  APPLE = 'apple.com',
  FACEBOOK = 'facebook.com',
  GITHUB = 'github.com',
  GOOGLE = 'google.com',
  TWITTER = 'twitter.com',
}
